import { ICONS } from '../icons/tabler';

/** Inline SVG icon from the placeholder set (see docs/icon-wishlist.md). */
export function Icon({ id, size = 16, className }: { id: string; size?: number; className?: string }) {
  return (
    <svg
      className={`icon ${className ?? ''}`}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      dangerouslySetInnerHTML={{ __html: ICONS[id] ?? ICONS.poi }}
    />
  );
}
